export type ViewingSlotPickerArgs = {
  id: string;

  /**
   * A mapping of values from the first select element to options for the second select element.
   */
  options: Record<string, Array<{label: string; value: string}>>;

  /**
   * The message to show when there are no options available for the target select element.
   */
  emptyMessage?: string;
};

function initViewingSlotPicker(el: Element) {
  const args = JSON.parse(el.getAttribute("data-viewing-slot-picker") ?? "{}") as ViewingSlotPickerArgs;
  if (!args.id) {
    throw new Error("Viewing slot picker ID is required");
  }

  const dateEl = document.getElementById(`${args.id}-date`);
  const timeEl = document.getElementById(`${args.id}-time`);
  if (!dateEl || !timeEl) {
    throw new Error("Viewing slot picker date and time elements not found");
  }

  const updateTargetOptions = () => {
    const sourceValue = (dateEl as HTMLSelectElement).value;
    const options = args.options[sourceValue] || [];
    console.log("source value", sourceValue);
    console.log("options", options);

    // Clear existing options
    while (timeEl.firstChild) {
      timeEl.removeChild(timeEl.firstChild);
    }

    if (options.length === 0) {
      const option = document.createElement("option");
      option.value = "";
      option.textContent = args.emptyMessage ?? "No options available";
      timeEl.appendChild(option);
    } else {
      for (const opt of options) {
        const option = document.createElement("option");
        option.value = opt.value;
        option.textContent = opt.label;
        timeEl.appendChild(option);
      }
    }
  };

  // Update options when source select changes
  dateEl.addEventListener("change", updateTargetOptions);

  // Initial update
  // updateTargetOptions();
}

const el = document.currentScript;
if (el) {
  initViewingSlotPicker(el);
}
